import { Component, Input } from '@angular/core';
import { PFFormatPersonalData } from '../../../../data/interfaces/circle-credit.interface';

@Component({
  selector: 'app-circle-credit-personal-data-card',
  templateUrl: './circle-credit-personal-data-card.component.html',
  styleUrls: ['./circle-credit-personal-data-card.component.scss']
})
export class CircleCreditPersonalDataCardComponent {
  @Input() data: PFFormatPersonalData | null = null;

  get hasData(): boolean {
    if (!this.data) return false;
    
    const essentialFields = ['lastNameFather', 'givenNames', 'rfc', 'curp'];
    return essentialFields.some(field => this.data![field as keyof PFFormatPersonalData]);
  }

  get completionPercentage(): number {
    if (!this.data) return 0;
    
    const allFields = [
      'lastNameFather', 'lastNameMother', 'additionalLastName', 'givenNames',
      'birthDate', 'rfc', 'curp', 'socialSecurityNumber', 'nationality',
      'residence', 'driverLicenseNumber', 'maritalStatus', 'sex',
      'voterKeyIFE', 'dependentsNumber', 'deathDate', 'deathIndicator', 'personType'
    ];
    
    const filledFields = allFields.filter(field => {
      const value = this.data![field as keyof PFFormatPersonalData];
      return value !== null && value !== undefined && value !== '';
    });
    
    return Math.round((filledFields.length / allFields.length) * 100);
  }

  get statusClass(): string {
    if (!this.hasData) return 'status-empty';
    
    const percentage = this.completionPercentage;
    if (percentage < 30) return 'status-incomplete';
    if (percentage < 70) return 'status-partial';
    return 'status-complete';
  }

  get fullName(): string {
    if (!this.data) return '';
    
    const parts = [
      this.data.givenNames,
      this.data.lastNameFather,
      this.data.lastNameMother,
      this.data.additionalLastName
    ].filter(part => part && part.trim());
    
    return parts.join(' ') || 'No especificado';
  }

  formatDate(date: string | undefined): string {
    if (!date) return 'No especificado';
    
    try {
      return new Date(date).toLocaleDateString('es-MX');
    } catch {
      return date;
    }
  }

  formatGender(sex: string | undefined): string {
    if (!sex) return 'No especificado';
    
    const genderMap: { [key: string]: string } = {
      'M': 'Masculino',
      'F': 'Femenino',
      'H': 'Masculino'
    };
    
    return genderMap[sex.toUpperCase()] || sex;
  }

  formatDeathIndicator(indicator: boolean | undefined): string {
    if (indicator === undefined || indicator === null) return 'No especificado';
    return indicator ? 'Sí' : 'No';
  }
}
